import { SSLSecurePayment, TrustBuilderBanner } from '@wix/package-picker-components';
import { AcceptedPaymentMethods } from './AcceptedPaymentMethods';
import { MoneyBackGuarantee } from './MoneyBackGuarantee';
export const TrustBuilders = {
  Banner: TrustBuilderBanner,
  AcceptedPaymentMethods,
  MoneyBackGuarantee,
  SSLSecurePayment
};
//# sourceMappingURL=TrustBuilders.js.map